export default __webpack_public_path__ + "static/media/AccumineBanner.1c1ebc9d.png";